import { render } from "./AdminLayout.vue?vue&type=template&id=4e9df996"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"
script.render = render

export default script